(function () {
  if (window.__BLOG_CODE_BLOCKS_INIT__) return;
  window.__BLOG_CODE_BLOCKS_INIT__ = true;

  function init() {
    document.querySelectorAll('.blog-post-content pre').forEach(function (pre) {
      // Skip if already wrapped
      if (pre.closest('.code-wrap')) return;

      var wrap = document.createElement('div');
      wrap.className = 'code-wrap';

      var header = document.createElement('div');
      header.className = 'code-header';

      var btn = document.createElement('button');
      btn.className = 'code-copy';
      btn.textContent = 'Copy';
      btn.addEventListener('click', function () {
        var code = pre.querySelector('code');
        var text = code ? code.innerText : pre.innerText;
        navigator.clipboard?.writeText(text).then(function () {
          btn.textContent = 'Copied!';
          setTimeout(function () { btn.textContent = 'Copy'; }, 1500);
        });
      });

      header.appendChild(btn);
      wrap.appendChild(header);

      pre.parentNode.insertBefore(wrap, pre);
      wrap.appendChild(pre);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
